<div class="root" (click)="gotoLive()">
    <div class="main">
        <div style="color: black;">{{message.Data.Title}}</div>
        <ng-container [ngSwitch]="message.LiveStatus">
            <div *ngSwitchCase="1" class="live-status-text">直播中</div>
            <div *ngSwitchCase="0" class="live-status-text">已结束</div>
        </ng-container>


    </div>
    <div class="foother">
        <i nz-icon style="color: #ff6146;" nzType="video-camera" nzTheme="outline"></i><span style="font-size: 10px;
        padding-left: 10px;color: #888888bf;">直播</span>
    </div>
</div>